import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import lightTheme from '@/themes/light';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: lightTheme
    },
    options: {
      customProperties: true
    }
  },
  breakpoint: {
    thresholds: {
      xs: 580
    }
  },
  icons: {
    iconfont: 'mdi',
    values: {
      volumeHigh: 'mdi-volume-high',
      volumeOff: 'mdi-volume-off',
      starFill: 'mdi-star',
      starBlank: 'mdi-star-outline',
      sound: 'mdi-music-note',
      sms: 'mdi-message-processing',
      email: 'mdi-email',
      whatsapp: 'mdi-whatsapp',
      batteryLow: 'mdi-battery-alert',
      alarmOn: 'mdi-bell-ring',
      alarmOff: 'mdi-bell',
      deviceNoResponse: 'mdi-alert-circle',
      gpsNotFixed: 'mdi-crosshairs',
      addPlan: 'mdi-map-plus',
      plan: 'mdi-map'
    }
  }
};

export default new Vuetify(opts);
